import { AbstractControl, ValidatorFn } from '@angular/forms';
import * as moment from 'moment';

export function dateValidator(min?: Date): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
        let returnValue = null;

        if (moment(control.value, "DD/MM/YYYY", true).isValid()) {
            if (min) {
                if (moment(control.value).isBefore(min)) {
                    returnValue = { 'datemin': true };
                }
            }
        } else {
            returnValue = {'date': true };
        }
        return returnValue;
    };
}
